import {isDesktopAndBelow, isTabletAndBelow} from "../Helpers/MediaQuery";

const selectors = {
    header: '.js--header',
    hamburger: '.js--h-button',
    menu: '.js--h-menu',
    body: 'body',
};

class Header {
    constructor() {
        this.header = document.querySelector(selectors.header);
        this.hamburger = document.querySelector(selectors.hamburger);
        this.menu = document.querySelector(selectors.menu);
        this.body = document.querySelector(selectors.body);
        this.submenu = document.querySelectorAll('.menu-item-has-children > a')

        if (!this.header) {
            return;
        }

        this.toggleMobileMenu();
        this.scrollUp();
        this.toggleSubMenu();
    }


    toggleMobileMenu() {
        this.hamburger.addEventListener('click', () => {
            this.hamburger.classList.toggle('open');
            this.header.classList.toggle('active');
            this.menu.classList.toggle('show');
            this.body.classList.toggle('body-overflow');
        });
    }

    toggleSubMenu() {
        if(isDesktopAndBelow() === true) {
            for(let i = 0; this.submenu.length > i; i++){
                this.submenu[i].nextElementSibling.classList.add('hidden');
                this.submenu[i].addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.submenu[i].nextElementSibling.classList.toggle('hidden');
                });
            }
        }


    }

    scrollUp(){
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll === 0) {
                body.classList.remove(scrollUp);
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });
    }


}

export default Header;
